import { GODAVARI_EVENT_TYPE } from 'src/utils/enum';

export const eventTypeCheck = (type) => {
  const isBatched = type === GODAVARI_EVENT_TYPE.BATCHED;
  const isPriority = type === GODAVARI_EVENT_TYPE.PRIORITY;
  return {
    isBatched,
    isPriority,
  };
};
